export default __webpack_public_path__ + "static/media/boilerextra.9ebb2f0d.jpg";